import React from 'react';
import { dynastyTheme } from '../../../../../services/colorService';
import PropTypes from 'prop-types';
import { mobileTextStyles } from '../../../../../services/mobileStyleService';

/**
 * TabNavigator (MTabs) — OPEN-ROW tab bar for the player modal (Unit 2a.1).
 * Top+bottom hairline only (no box/fill), INSET vertical dividers between cells
 * (absolute span, not a full-height border), taller cells (padding 10px 0),
 * gold-TEXT active (no underline, no fill). Handles the locked 6-tab set.
 */
const C = dynastyTheme.tokens.colors;
const GOLD = dynastyTheme.tokens.colors.primary;
const HAIRLINE = `1px solid ${C.border}`;

const TabNavigator = ({ tabs, activeTab, onChange }) => (
  <div style={{ width: '100%', borderTop: HAIRLINE, borderBottom: HAIRLINE }}>
    <div style={{ display: 'flex', alignItems: 'stretch' }}>
      {tabs.map((tab, i) => {
        const isActive = activeTab === tab;
        return (
          <button
            key={tab}
            onClick={() => onChange(tab)}
            aria-selected={isActive}
            data-active={isActive ? 'true' : 'false'}
            role="tab"
            style={{
              flex: 1, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center',
              border: 'none', background: 'transparent', cursor: 'pointer', padding: '10px 0',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            {i > 0 && (
              <span aria-hidden="true" style={{ position: 'absolute', left: 0, top: 5, bottom: 5, width: 1, background: C.border }} />
            )}
            <span style={{
              ...mobileTextStyles.tabLabel,
              color: isActive ? GOLD : C.coolGray[650], userSelect: 'none', whiteSpace: 'nowrap',
            }}>{tab}</span>
          </button>
        );
      })}
    </div>
  </div>
);

TabNavigator.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TabNavigator;
